import { useEffect } from "react";

export default function usePopulateProposalItems(rentItems, rideItems, shopItems, setPurchasePages, setRentPages) {
    useEffect(() => {
      if (!rentItems || !rideItems || !shopItems) {
        return;
      }
  
      const purchasePagesItems = { ...shopItems };
      const unsortedRentPagesItems = { ...rentItems, ...rideItems };
      const rentPagesItems = {};
  
      const permanentKey = "Rental item | ";
  
      const sortingOrder = [
        "Clean",
        "Play",
        "Cook",
        "Host",
        "Fitness",
        "DIY",
        "OutDoor",
        "Ride",
      ].map((item) => {
        if (item === "Ride") {
          return item;
        }
        const key = permanentKey + item;
        return key;
      });
  
      Object.keys(unsortedRentPagesItems)
        .sort((a, b) => {
          return sortingOrder.indexOf(unsortedRentPagesItems[b]?.item.category) >
            sortingOrder.indexOf(unsortedRentPagesItems[a]?.item.category)
            ? 1
            : -1;
        })
        .reduce((acc, element) => {
          if (unsortedRentPagesItems[element].item.title === "Printer") {
            return [...acc, element];
          }
          return [element, ...acc];
        }, [])
        .forEach((key, index) => {
          rentPagesItems[key] = unsortedRentPagesItems[key];
        });
  
      const purchasePages = [];
      const rentPages = [];
  
      let fifteenUnitsObj = {};
      for (let i = 0; i < Object.keys(purchasePagesItems).length; i++) {
        const key = Object.keys(purchasePagesItems)[i];
        const item = purchasePagesItems[key];
  
        fifteenUnitsObj[key] = item;
  
        if (Object.keys(fifteenUnitsObj).length === 15 ||
          Object.keys(purchasePagesItems).length === i + 1) {
          purchasePages.push(fifteenUnitsObj);
          fifteenUnitsObj = {};
        }
      }
  
      fifteenUnitsObj = {};
      for (let i = 0; i < Object.keys(rentPagesItems).length; i++) {
        const key = Object.keys(rentPagesItems)[i];
        const item = rentPagesItems[key];
  
        fifteenUnitsObj[key] = item;
  
        if (Object.keys(fifteenUnitsObj).length === 15 ||
          Object.keys(rentPagesItems).length === i + 1) {
          rentPages.push(fifteenUnitsObj);
          fifteenUnitsObj = {};
        }
      }
      setPurchasePages(purchasePages);
      setRentPages(rentPages);
    }, [rentItems, rideItems, shopItems, setPurchasePages, setRentPages]);
  }